define(['moduler'], function (Moduler) {
    'use strict';

    /**
     * Notice manager for non-disruptive visitor notices displayed at the top of window.
     */

    return Moduler.create({
        defaults: {
            visitorNotice: '.js-visitorNotice'
        },

        init: function () {
            var self = this;

            self.notices = self.el.querySelectorAll(self.options.visitorNotice);

            self.el.addEventListener('click', function (e) {
                var acceptClose = e.target.closest('.js-acceptAndClose');
                var close = e.target.closest('.js-close');
                if (close != null || acceptClose != null) {
                    e.preventDefault();
                    var notice = e.target.closest(self.options.visitorNotice);
                    self.hideNotice(notice, acceptClose != null);
                }
            });
        },

        hideNotice: function (notice, setCookie) {
            var self = this,
                visitorNoticesLeft = self.notices.length,
                fadeFn = visitorNoticesLeft > 1 ? 'fadeOut' : 'slideUp',
                cookieName = notice.getAttribute('data-cookie-name'),
                cookieExpires = notice.getAttribute('data-cookie-expires');

            if (setCookie && cookieName) {
                self.setCookie(cookieName, cookieExpires);
            }

            Moduler.utils.fadeOut(notice, 200, function () {
                notice.parentElement.removeChild(notice);
                self.notices = self.el.querySelectorAll(self.options.visitorNotice);
                if (self.notices.length > 0) {
                    self.notices[0].classList.remove('u-hidden');
                    Moduler.utils.fadeIn(self.notices[0], 200);
                }
            });
        },

        setCookie: function (cookieName, cookieExpiresIn) {
            var expires = '';
            if (cookieExpiresIn > 0) {
                var date = new Date();
                date.setTime(date.getTime() + (cookieExpiresIn * 60 * 1000));
                expires = ';expires=' + date.toUTCString();
            }

            document.cookie = cookieName + '=seen' + expires + ';SameSite=Strict;path=/';
        }
    });
});